import Import from '@feature/Import'
import { CssBaseline, ScopedCssBaseline, ThemeProvider } from '@mui/material'
import { history } from 'app/routerReducer'
import { ADMIN_MODE, STANDALONE } from 'config'
import { ConnectedRouter } from 'connected-react-router'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider as StoreProvider } from 'react-redux'
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
import theme from 'theme/theme'
import App from './App'
import { store } from './app/store'
// import * as serviceWorker from './serviceWorker'

const persistor = persistStore(store)

ReactDOM.render(
  <React.StrictMode>
    <StoreProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {/**
         * Set the ENV variable `REACT_APP_ADMIN=1` to work on the `Import` screen
         * */}
        {ADMIN_MODE ? (
          <ScopedCssBaseline>
            <Import />
          </ScopedCssBaseline>
        ) : (
          <>
            <ConnectedRouter history={history}>
              <ThemeProvider theme={theme}>
                {STANDALONE ? (
                  // Full css reset for standalone mode
                  <>
                    <CssBaseline />
                    <App />
                  </>
                ) : (
                  // Scoped css baseline when mounting in the site
                  <ScopedCssBaseline>
                    <App />
                  </ScopedCssBaseline>
                )}
              </ThemeProvider>
            </ConnectedRouter>
          </>
        )}
      </PersistGate>
    </StoreProvider>
  </React.StrictMode>,
  document.getElementById('_ftpf-root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register()
